"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEntity = void 0;
const ee_1 = require("ee-ts/lib/ee");
/**
 * Represents the base Client-side entity implementation. All client-side entity types are derived
 * from this class.
 */
class CSEntity extends ee_1.EventEmitter {
    constructor(manifest, instanceID, initialLocalStore, animationManager) {
        super();
        this._baseManifest = manifest; // TODO - Verify that this can be overloaded properly with narrower types. - Can we come up with something better?
        this._entityState = manifest.initialEntityState;
        this._instanceID = instanceID;
        this._animationManager = animationManager;
        this._decorationRenderers = [];
        this._localStore = initialLocalStore;
    }
    // TODO - Rename the below or something
    // TODO - Add all the missing pieces back to this
    doDecorationRenderer(context) {
        this._decorationRenderers.forEach((renderer) => renderer(context));
    }
    renderDecoration(renderer) {
        this._decorationRenderers.push(renderer);
    }
    get baseManifest() {
        return this._baseManifest;
    }
    get instanceID() {
        return this._instanceID;
    }
    get entityState() {
        return this._entityState;
    }
    get localStore() {
        return this._localStore;
    }
    get animationManager() {
        return this._animationManager;
    }
}
exports.CSEntity = CSEntity;
//# sourceMappingURL=CSEntity.js.map